import { RootState } from "../redux/reducers";
import useFetch from "./useFetch";
import {
  TypedUseSelectorHook,
  useDispatch,
  useSelector as useReduxSelector,
} from "react-redux";
import { useEffect, useState } from "react";
import { ErrorApi } from "../types";

export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;

function useStore<T>(
  params: any, // paramètres requis pour appeler l'API (dans le path, body...)
  url: string, // URL qui correspond à l'operationID de l'API
  handleStore: any, // Action redux  pour stocker la réponse
  getListe: any, // constante pour récupérer la valeur stockée dans Redux
  shouldExecute?: boolean // boolean pour déclencher l'exécution de l'API
): { liste: T | undefined; error: ErrorApi | undefined; fetching: boolean } {
  const dispatch = useDispatch();
  const liste = useSelector((state) => getListe(state)); // récupération de la valeur dans Redux

  const [executing, setExecuting] = useState<boolean>();

  useEffect(() => {
    if (shouldExecute === false) {
      setExecuting(false);
    } else {
      setExecuting(!liste || liste.length === 0);
    }
  }, [shouldExecute, liste]);
  //const shouldExecuteState = shouldExecute ? shouldExecute : !liste || liste.length === 0; // boolean qui permet de déclencher l'appel. S'execute seulement si la valeur est vide ET si "shouldExecute" est à true
  const { response, fetching, error } = useFetch<T>(params, url, executing); // appel du hook useFetch

  (!liste || liste.length === 0) && response && dispatch(handleStore(response)); // enregistrement de la valeur dans le reducer si celle ci existe

  return { liste, error, fetching };
}
export default useStore;
